import { render } from "./Notas.vue?vue&type=template&id=4ce479a3&scoped=true"
import script from "./Notas.vue?vue&type=script&lang=js"
export * from "./Notas.vue?vue&type=script&lang=js"

import "../../main.css?vue&type=style&index=0&lang=css&external"
import "./Notas.vue?vue&type=style&index=1&id=4ce479a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce479a3"]])

export default __exports__